"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mda(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M15.4972 5.994C16.4093 6.969 16.875 8.193 16.875 9.624C16.875 11.0767 16.4093 12.3015 15.4965 13.2765C14.7668 14.0437 13.8953 14.4998 12.882 14.6663V15.5167H14.949V16.4505H12.861V16.9485H14.949V17.8193H12.882V19.5H11.118V17.82H9.0705V16.9485H11.1382V16.4505H9.07125V15.5167H11.1187V14.6453C10.125 14.4795 9.2535 14.0227 8.52375 13.2555C7.5915 12.2805 7.125 11.0558 7.125 9.60375C7.125 8.13075 7.57125 6.90675 8.5035 5.952C9.435 4.977 10.5915 4.5 12.0105 4.5C13.4092 4.5 14.5642 4.977 15.4972 5.994ZM13.5915 11.5335C13.9762 11.0355 14.1795 10.392 14.1795 9.60375C14.1795 8.8365 13.977 8.19375 13.551 7.695C13.146 7.17675 12.6188 6.92775 12.0105 6.92775C11.382 6.92775 10.8555 7.17675 10.4497 7.67475C10.0432 8.17275 9.84075 8.7945 9.84075 9.5835C9.84075 10.392 10.044 11.0355 10.4497 11.5335C10.8555 12.0315 11.382 12.2805 12.0098 12.2805C12.6593 12.2805 13.206 12.0315 13.5915 11.5335Z", fill: color }));
}
exports["default"] = mda;
//# sourceMappingURL=mda.js.map